import React, { memo, useCallback, useState } from 'react'
import { GTextareaCom, Input } from '../../../Components/AllInput/AllInput'
import ReactSelect from '../../../Components/New/Select/ReactSelect'
import { capitalizedWordOfSentence } from '../../../Utils/commonFunctions'
import { UserAddressTy } from './UserAddressModal'
import { useAppSelector } from '../../../ReduxTool/store/hooks'
import { AxiosResponse } from 'axios'
import { APIResponse } from '../../../Utils/Const'
import { districtNameResponseTy } from '../../../ReduxTool/Slice/GeneralSlice/type'
import { baseURL, requestUrl } from '../../../Utils/baseUrls'

 async function fetchDistrictsByStateId(stateId: string[]): Promise<districtNameResponseTy[]> {
  const { data }: AxiosResponse<APIResponse<districtNameResponseTy[]>> = await baseURL.post(requestUrl.getDistrictsNameByStateID, stateId)
  if (data.code !== '200') return []
  return data.responseData?.sort((a, b) => a.district.localeCompare(b.district)) ?? []
}

interface UserAddressProps {
  userAddress: UserAddressTy
  error: any
  addressLoading?: boolean
  handleChange: (props: any, selectedOption?: any) => void
  postalMaxLength?: number
}

function UserAddress({userAddress,error,addressLoading=false,handleChange,postalMaxLength}: UserAddressProps) {
 const { statesList } = useAppSelector((state) => state.CountrySlice)

  const [districtsList, setDistrictsList] = useState<districtNameResponseTy[]>([])
  const [districtsLoading, setDistrictsLoading] = useState(false)

  const handleStateChange = useCallback(async (props: any, selectedOption?: any) => {
    handleChange(props, selectedOption) // let parent update state + reset city

    const stateId = selectedOption ? props?.value : props?.target?.value
    if (!stateId) return

    try {
      setDistrictsLoading(true)
      const districts = await fetchDistrictsByStateId([stateId])
      setDistrictsList(districts)
    } catch {
      setDistrictsList([])
    } finally {
      setDistrictsLoading(false)
    }
  }, [handleChange])

 
  const stateOptions = statesList.map((item: any) => ({ label: item.state, value: item.stateid, }))
  const districtOptions = districtsList.map((item) => ({ label: item.district, value: item.district, }))
  const stateValue = userAddress.state ? { label: userAddress.state, value: userAddress.state } : null
  const cityValue = userAddress.city ? { label: userAddress.city, value: userAddress.city } : null

  return (
     <>
            <div className="pb-4">
             <div className="grid grid-cols-1 p-1 gap-x-2 gap-y-2">
            <Input smpadding  id={"Country"} isRequired isBtnLoading={addressLoading} label={`Country`} name={"country"} /* value={countryName} */ value={userAddress?.country} error={error?.country} type={"text"} onChange={()=>{}} disabled={true} />
            <ReactSelect smpadding menuPlacement="bottom" isLoading={addressLoading} isrequired isSearchable={true}  error={error.state} onChange={handleStateChange} options={stateOptions} value={stateValue} closeMenuOnSelect key="state" labelname="State/Province/Region" name="state" placeholder="Select an option" disabled={false}   />
            <ReactSelect smpadding menuPlacement="bottom" isLoading={addressLoading} isrequired isSearchable={true} error={error.city} onChange={handleChange} options={districtOptions} value={cityValue} closeMenuOnSelect key="city" labelname="District/City" name="city" placeholder="Select an option" disabled={false}  />
            <Input smpadding isRequired isBtnLoading={addressLoading}  disabled={false} id={"Zip/Pin code"} label={`Zip/Postal code`} name={"pincode"} maxLength={postalMaxLength} value={userAddress?.pincode} error={error?.pincode} type={"text"} onChange={handleChange} />
            <GTextareaCom smpadding disabled={false} max={`100 words | ${userAddress?.address?.length || 0} / 100 `} helpertext={`H No/Flat No, colony/building name, street name, area`} error={error?.address} 
             placeholder='Briefly describe your location ..' id={"AddressLine1"} label={"Street address"} name={"address"} value={capitalizedWordOfSentence(userAddress?.address)} 
             type="text" onChange={handleChange} isRequired={true}  /> 
             <div className="p-0"></div>
            
            {/* <Input  disabled={selected_project?.iscompleted} id={"AddressLine1"} label={`Address line`} name={"addressline1"} value={capitalizedWordOfSentence(projectSetup.addressline1)} helpertext="H.NO,Street address,P.O Box,etc." error={error?.addressline1} type={"text"} onChange={handleChange}  />  */}
            {/* <Input id={"Site Location"} label={`Site location`} name={"sitelocation"} value={projectSetup.address} type={"text"} onChange={handleChange} disabled={true} /> */}
          </div>
          </div>
           </>
  )
}

export default memo(UserAddress)

// (selected_project?.consumer_subprojectstatus?? 0) >=3
